








































































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay } from '@/utils/dateTime'
import { Case } from '@/modules/Case/interfaces/case'
import FoldingCard from '@/components/FoldingCard.vue'
import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import PolicyDialog from '../../Policy/scripts/policy-dialog'
import { quoteStatus, quoteStatusClass, quoteType } from '@/modules/Quote/helpers/quote'

@Component({
  components: {
    FoldingCard
  }
})
export default class CaseDetailQuote extends mixins(QuoteDialog, PolicyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  quoteStatus = quoteStatus
  quoteStatusClass = quoteStatusClass
  quoteType = quoteType

  tableColumn = [
    { field: 'name',
      title: 'Quote Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'accountName',
      title: 'Account Name',
      slots: { default: 'account_name_default' },
      resizable: true
    },
    { field: 'contactName',
      title: 'Contact Name',
      slots: { default: 'contact_name_default' },
      resizable: true
    },
    { field: 'status', title: 'Quote Status', slots: { default: 'status_default' }, resizable: true, width: 140 },
    { field: 'type', title: 'Quote Type', slots: { default: 'type_default' }, width: 140 },
    { field: 'createdAt',
      title: 'Creation Time',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.createdAt ? dateTimeToDisplay(row.createdAt) : '-')
        ]
      }
      },
      width: 180
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 100 }
  ]

  get QuotesList () {
    return this.caseInfo.quotes || []
  }

  get relatedQuotesList () {
    return this.caseInfo.relatedQuotes || []
  }

  dateTimeToDisplay = dateTimeToDisplay

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  routeToQuoteDetail (item: any, ifEdit = 'false') {
    this.$router.push({
      name: 'QuoteDetailDetail',
      params: {
        id: item.id,
        edit: ifEdit
      }
    })
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'CaseRelatedQuotesList',
      params: {
        id: this.caseInfo.id + '',
        type: type
      }
    })
  }

  routeToAccountDetail (item: any) {
    if (!item.account) {
      return
    }
    this.$router.push({
      name: 'AccountDetailDetail',
      params: {
        id: item.account.id
      }
    })
  }

  routeToContactDetail (item: any) {
    if (!item.primaryContact) {
      return
    }
    this.$router.push({
      name: 'ContactDetailDetail',
      params: {
        id: item.primaryContact.id
      }
    })
  }

  async deleteQuoteConfirm () {
    await this.deleteQuotePost()
    this.onSuccess()
  }
}
